import axiosClient from "../api/axiosClient.js";
import { useState } from "react";
import { Box, Typography, Button } from "@mui/material";

export const ImageUploader: React.FC<{
    matchId: number;
    photoType: "team_photo" | "report_photo";
    imageUrl?: string;
    onUpload?: () => void;
}> = ({ matchId, photoType, imageUrl, onUpload }) => {
    const [uploading, setUploading] = useState(false);

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files?.length) return;
        const file = event.target.files[0];

        const formData = new FormData();
        formData.append("file", file);
        formData.append("matchId", matchId.toString());
        formData.append("photoType", photoType);

        try {
            setUploading(true);
            await axiosClient.post(`/matches/image/upload`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            if (onUpload) onUpload();
        } catch (err) {
            console.error("Upload failed", err);
            alert("Upload failed");
        } finally {
            setUploading(false);
        }
    };

    return (
        <Box sx={{ textAlign: "center" }}>
            {imageUrl && (
                <>
                    <img
                        src={imageUrl}
                        alt={photoType}
                        style={{ width: "100%", maxWidth: 160, height: 100, objectFit: "cover", borderRadius: 8 }}
                        onClick={() => window.open(imageUrl, "_blank")}
                    />
                    <Typography variant="subtitle2">{photoType === "team_photo" ? "Team" : "Referto"}</Typography>
                </>
            )}
            <Button
                variant="outlined"
                component="label"
                size="small"
                sx={{ mt: 1 }}
                disabled={uploading}
            >
                {uploading ? "Uploading..." : imageUrl ? "Update" : "Upload"}
                <input type="file" hidden accept="image/*" onChange={handleFileChange} />
            </Button>
        </Box>
    );
};
